import * as React from 'react';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { getBidderEmail } from '@/redux/modules/account/user/user.selectors';
import { getManageCategoryNotificationsUrl } from '@/utils/urls';
import { useAppSelector } from '@/redux/hooks';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import styled, { useTheme } from 'styled-components';
import TableRow from './TableRow';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';
import useWindowSize from '@/hooks/useWindowSize';

const ManageCategoryNotifications = () => {
    const bidderEmail = useAppSelector(getBidderEmail);

    const { width } = useWindowSize();
    const {
        breakpoints: { tabletNarrowWidthNum },
    } = useTheme();
    return (
        <StyledTableRow
            email={
                <Link
                    target="_blank"
                    to={getManageCategoryNotificationsUrl(bidderEmail)}
                >
                    <FormattedMessage id="notificationsPage.table.managePreferencesRow.link" />
                </Link>
            }
            frequency={
                width > tabletNarrowWidthNum && (
                    <FormattedMessage id="notificationsPage.table.managePreferencesRow.frequency" />
                )
            }
            type={
                <>
                    <Text
                        h5={width > tabletNarrowWidthNum}
                        h6={width <= tabletNarrowWidthNum}
                    >
                        <FormattedMessage id="notificationsPage.table.managePreferencesRow.title" />
                    </Text>
                    <Text
                        caption={width <= tabletNarrowWidthNum}
                        colorPrimaryWeak
                        secondary={width > tabletNarrowWidthNum}
                    >
                        <FormattedMessage id="notificationsPage.table.managePreferencesRow.description" />
                    </Text>
                </>
            }
        />
    );
};

const StyledTableRow = styled(TableRow)`
    @media (max-width: ${({ theme }) => theme.breakpoints.tabletNarrowWidth}) {
        > :nth-child(1) {
            grid-column: 1 / 5;
        }
    }
`;

export default ManageCategoryNotifications;
